import React, { Component } from "react";
import StoresDropdown from "../StoresDropdown/";
import { Navigate } from "react-router-dom";
import PageTitle from "../PageTitle";
import { Grid, GridItem } from "@sainsburys-tech/fable";

class StoresPage extends Component {
  state = {
    storeId: this.props.storeId
  };

  handleStoreChanged = store => {
    if (!store) {
      return;
    }
    const storeId = store.value;
    this.setState({ storeId: storeId });
  };

  render() {
    if (this.state.storeId) {
      return (
        <PageTitle>
          <Navigate to={`/stores/${this.state.storeId}`} replace />
        </PageTitle>
      );
    }
    return (
      <PageTitle title="Stores">
        <Grid cols={{ xl: 4, lg: 3, md: 3, sm: 3, xs: 2, default: 2 }}>
          <GridItem colSpan={1}>
            <div style = {{marginTop: '-10px'}}>
              <StoresDropdown
                handleStoreChanged={this.handleStoreChanged}
                storeId={this.state.storeId}
                stores={this.props.stores}
              />
            </div>
          </GridItem>
        </Grid>
      </PageTitle>
    );
  }
}

export default StoresPage;
